<template>
  <modal name="eventStaffingDetailModal" class="custom-modal" :width="'75%'" :height="'auto'"
         :scrollable="true" :pivotX="1.0" :minWidth="900" :minHeight="900" @before-open="beforeOpen" @before-close="beforeClose"
         :clickToClose="true">
    <div class="event-detail">
      <div :class="{'isLoading': getIsLoading, 'noDisplay': !getIsLoading}" class="overlay">
        <div class="spinner-align">
          <Icon name="spinner" scale="5" pulse class="icon-size"></Icon>
        </div>
      </div>
      <div v-if="!getIsLoading" id="staffing-section" class="staffing-section margin-side modal-padding">
      <div class="row">
        <div class="col-md-6 page-title h2-text">
          <span>Staff & Slot Management</span>
          <span class="seperate-name"></span>
          <span>{{eventName}}</span>
        </div>
        <div class="col-md-6 noPaddingRight align-right-item">
          <div class="modal-close-img" @click="back()">
            <div class="icon-close"></div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="row time-management-container">
            <div class="time-slots">
              Time Management
            </div>
            <button class="ap-btn btn-cancel" @click="onCancelAllAppointments()">Cancel All Appointments</button>
          </div>
          <div class="duration-slide-container">
            <div class="staffing-title">
              slot duration
            </div>
            <div class="row">
              <div class="duration-slide">
                <vue-slider ref="slider" class="" v-bind="duration" v-model="getStaffingDuration"
                            @click.native="getValue('slider')"/>
              </div>
              <button class="ap-btn tertiary change-duration-button">change duration</button>
            </div>
          </div>
        </div>

        <div class="col text-entry-field-wrapper">
          <div>
            <span class="text-entry-title">ShiftBoard Lead WorkGroup</span>
            <multiselect v-model="shiftboard.leadTitle"
                         :options="shiftboard.workgroups"
                         placeholder="Choose Lead WorkGroup"
                         label="name"
                         class="multiple-select-work-group"
                         :openDirection="'below'"
                         :multiple="false"
                         :close-on-select="true"
                         :hide-selected="true"
                         track-by="id"
                         :allow-empty="false"
                         :show-labels="false"
                         @select="onShiftboardDropdown($event, 'lead')"
                         :disabled="false">
            </multiselect>
          </div>

          <div>
            <span class="text-entry-title">ShiftBoard Screener WorkGroup</span>
            <multiselect v-model="shiftboard.screenerTitle"
                         :options="shiftboard.workgroups"
                         placeholder="Choose Screener WorkGroup"
                         label="name"
                         class="multiple-select-work-group"
                         :openDirection="'below'"
                         :multiple="false"
                         :close-on-select="true"
                         :hide-selected="true"
                         track-by="id"
                         :allow-empty="false"
                         :show-labels="false"
                         @select="onShiftboardDropdown($event, 'screener')"
                         :disabled="false">
            </multiselect>
          </div>

          <div>
            <span class="text-entry-title">ShiftBoard Phlebotomist WorkGroup</span>
            <multiselect v-model="shiftboard.phlebotomistTitle"
                         :options="shiftboard.workgroups"
                         placeholder="Choose Phlebotomist WorkGroup"
                         label="name"
                         class="multiple-select-work-group"
                         :openDirection="'below'"
                         :multiple="false"
                         :close-on-select="true"
                         :hide-selected="true"
                         track-by="id"
                         :allow-empty="false"
                         :show-labels="false"
                         @select="onShiftboardDropdown($event, 'phlebotomist')"
                         :disabled="false">
            </multiselect>
          </div>
        </div>
      </div>

        <div class="row">
          <div class="col-md-12 time-slots">
            Staff Management
          </div>
        </div>
        <div class="row staff-management-container">
          <div class="col-md-6">
            <StaffManagement :maxValueStaff="maxStaffLead || 0" :eventId="eventId" :staffRole="'lead'"
                            v-on:assign-successful="getEventStaff(eventId)"
                            v-on:add-remove-staff="addOrRemoveStaff"
                            />
          </div>
          <div class="col-md-6">
            <StaffManagement :maxValueStaff="maxStaffConcierge || 0" :eventId="eventId"
                            :staffRole="'phlebotomist'"
                            v-on:assign-successful="getEventStaff(eventId)"
                            v-on:add-remove-staff="addOrRemoveStaff"
                            />
          </div>
          <div class="col-md-12 margin-top-25px">
            <StaffManagement :maxValueStaff="maxStaffScreener || 0" :eventId="eventId"
                            :staffRole="'screener'"
                            v-on:assign-successful="getEventStaff(eventId)"
                            v-on:add-remove-staff="addOrRemoveStaff"
                            ></StaffManagement>
          </div>
        </div>
        <div class="" v-if="isLoadingAppointment">
          <Spinner></Spinner>
        </div>
        <div class="row"  v-else>
          <div :class="event.fluShot ? 'col-md-6' : 'col-md-12'">
          <!--<div class="col-md-6">-->
            <SlotsTable v-if="eventDetail" :title="'Screeners'"
                        :eventDetail="eventDetail"
                        :eventId="eventId"
                        :addOns = "event.addOns"
                        v-on:updateSlots="renderEventStaffing"
                        :maxValueStaff="maxAppointmentPerslot"
                        v-on:RELOAD_TABLE_STAFFING="requestReloadTableStaffing"
                        ref="updateSlots"
                        v-on:add-remove-staff="addOrRemoveStaff"
                        :fluShot="event.fluShot"
                        ></SlotsTable>
          </div>
          <div class="col-md-6" v-if="event.fluShot !== -1">
            <SlotsTable :title="'Slots'"
                        :eventDetail="eventDetail"
                        :eventId="eventId"
                        :addOns = "event.addOns"
                        v-on:RELOAD_TABLE_STAFFING="requestReloadTableStaffing"
                        ref="updateSlotsFluShot"
                        :fluShot="event.fluShot"
            ></SlotsTable>
          </div>
        </div>
      </div>
      <PatientDetailModal></PatientDetailModal>
      <ScrollTop></ScrollTop>
      <ModalCancellAllAppointment
        :eventId="eventId"
        :getEventStaffingById="getEventStaffingById"
      >
      </ModalCancellAllAppointment>
    </div>
  </modal>
</template>

<script>
  // import consts from '../../_consts';
  import {mapActions, mapGetters, mapMutations} from 'vuex';
  import VueSlider from 'vue-slider-component';
  import Icon from 'vue-awesome/components/Icon';
  import ScrollTop from '../../components/utils/ScrollTop';
  import StaffManagement from '../../components/eventManagement/eventDetail/StaffManagement';
  import PatientDetailModal from '../../components/modal/patient/PatientDetailModal';
  import SlotsTable from '../../components/slots/SlotsTable';
  import Spinner from '@/components/commons/Spinner';
  import ModalCancellAllAppointment from '@/components/modal/ModalCancellAllAppointment';
  import Multiselect from 'vue-multiselect';

  export default {
    name: 'event-staffing-detail',
    components: {
      VueSlider,
      Icon,
      PatientDetailModal,
      ScrollTop,
      StaffManagement,
      SlotsTable,
      Spinner,
      ModalCancellAllAppointment,
      Multiselect
    },
    props: {},
    data () {
      return {
        historyRouter: null,
        event: {},
        eventDetail: {},
        duration: {
          value: 15,
          width: 'auto',
          dotSize: 15,
          tooltip: false,
          disabled: false,
          piecewise: true,
          piecewiseLabel: true,
          data: [
            5,
            15,
            20
          ],
          piecewiseStyle: {
            backgroundColor: 'transparent', // #00A4D6
            visibility: 'visible',
            width: '15px',
            height: '15px'
          },
          piecewiseActiveStyle: {
            backgroundColor: 'transparent',
            width: '15px',
            height: '15px',
            visibility: 'visible'
          },
          processStyle: {
            'backgroundColor': 'transparent'
          }
        },
        numberColumn: 0,
        startColumn: 0,
        numberShowColumn: 0,
        selectedItemIds: [],
        selectedItems: [],
        selectedRows: [],
        selectedColumns: [],
        eventId: 0,
        maxStaffLead: 0,
        maxStaffConcierge: 0,
        maxStaffScreener: 0,
        isLoading: true,
        eventName: null,
        maxAppointmentPerslot: 0,
        onChangeEventDetail: null,
        isLoadingAppointment: true,
        shiftboard: {
          leadTitle: null,
          screenerTitle: null,
          phlebotomistTitle: null,
          workgroups: []
        }
      }
    },
    methods: {
      beforeOpen (params) {
        let eventId = params.params.eventId;
        this.eventName = params.params.eventName;
        this.eventId = eventId;
        this.historyRouter = params.routerName;
        this.onChangeEventDetail = params.params.onChangeEventDetail;
        // get Event Staffs
        this.getEventStaff(eventId).then(response => {
          this.maxStaffLead = response.maxStaffLead;
          this.maxStaffConcierge = response.maxStaffConcierge;
          this.maxStaffScreener = response.maxStaffScreener;
          this.maxAppointmentPerslot = response.maxAppointmentPerslot;
        });

        this.getEventDetailsById();
      },
      beforeClose () {
      },
      onShiftboardDropdown (item, role) {
        switch (role) {
          case 'lead':
            this.shiftboard.leadTitle = item;
            this.event.sbWorkgroupId = item.id;
            break;
          case 'screener':
            this.shiftboard.screenerTitle = item;
            this.event.sbScreenerWorkgroupId = item.id;
            break;
          case 'phlebotomist':
            this.shiftboard.phlebotomistTitle = item;
            this.event.sbPhlebotomistWorkgroupId = item.id;
            break;
        }
        this.updateEventShiftboard({eventId: this.event.id, workgroupId: item.id, role: role});
      },
      requestReloadTableStaffing () {
        this.getEventDetailsById();
      },
      updateEventStaffingGroups (obj) {
        this.maxAppointmentPerslot = obj.maxAppointmentPerslot;
        this.eventDetail.eventSlotGroups = obj.eventSlotGroups;
        this.eventDetail.numStaffs = obj.numStaffs;
        // this.renderEventStaffing(this.eventDetail);
        this.$refs.updateSlots.renderEventStaffing(this.eventDetail);
      },
      back () {
        this.$modal.hide('eventStaffingDetailModal');
      },
      getValue (name) {
        let slider = this.$refs[name];
        let eventId = this.$route.params.eventId || null;
        let body = {
          duration: slider.getValue(),
          blocked: null,
          eventId: eventId
        };
        this.changeDuration(body).then(response => {
          if (response.message === null) {
            // this.renderEventStaffing(response);
            this.$refs.updateSlots.renderEventStaffing(response);
            this.$refs.updateSlotsFluShot.renderEventStaffing(response);
          } else {
            this.$toastr('error', 'Unsuccessfully getting duration!', '');
          }
        })
      },
      updateStaffMaxValueToParent (obj) { // this function is used to update the max value staff of each role from child component.
        switch (obj.role) {
          case 'screener':
            this.maxStaffScreener = obj.staff;
            break;
          case 'lead':
            this.maxStaffLead = obj.staff;
            break;
          case 'concierge':
            this.maxStaffConcierge = obj.staff;
            break;
        }
      },
      getEventDetailsById () {
        this.isLoading = true;
        this.getEventById(this.eventId).then(response => {
          this.event = response.event;
          this.getEventStaffingById();
          this.getSBWorkgroups().then(response => {
            this.shiftboard.workgroups = response;
            this.shiftboard.leadTitle = response.find(x => x.id === this.event.sbWorkgroupId);
            this.shiftboard.screenerTitle = response.find(x => x.id === this.event.sbScreenerWorkgroupId);
            this.shiftboard.phlebotomistTitle = response.find(x => x.id === this.event.sbPhlebotomistWorkgroupId);
          });
        }).catch(() => {
          this.isLoading = false;
        })
      },
      addOrRemoveStaff (params) {
        let data = {
          eventId: this.eventId,
          ...params
        };
        this.addOrRemove(data).then(response => {
          if (response.message === null) {
            this.updateStaffMaxValueToParent({
              staff: response.maxStaff,
              role: params.eventStaffRole
            });
            if (response.eventStaffRole === 'screener') {
              this.updateEventStaffingGroups({
                numStaffs: response.maxStaff || 0,
                eventSlotGroups: response.eventSlotGroups || [],
                maxAppointmentPerslot: response.eventSlotGroups[0].eventSlots.length
              });
            }
            this.onChangeEventDetail({
              maxStaffLead: this.maxStaffLead,
              maxStaffConcierge: this.maxStaffConcierge,
              maxStaffScreener: this.maxStaffScreener
            });
          }
        });
      },
      getEventStaffingById () {
        this.isLoadingAppointment = true;
        this.getEventStaffing(this.eventId).then((res) => {
          if (res.message === null) {
            // store boolean: if can add participant or not
            localStorage.setItem('IS_ADDED_PARTICIPANT', res.allowWithoutLimeade);
            this.eventDetail = res;
            setTimeout(() => {
              if (this.$refs.updateSlots) {
                this.$refs.updateSlots.renderEventStaffing(this.eventDetail);
              }

              if (this.eventDetail.eventSlotGroupsFLuShotOnly && this.eventDetail.eventSlotGroupsFLuShotOnly.length && this.$refs.updateSlotsFluShot) {
                this.$refs.updateSlotsFluShot.renderEventStaffing(this.eventDetail);
              }
            }, 1000);
          }
        }).finally(() => {
          this.isLoadingAppointment = false;
        });
      },
      ...mapActions({
        changeDuration: 'ACTION_CHANGE_DURATION',
        getEventById: 'ACTION_GET_EVENT_BY_ID',
        getEventStaffing: 'ACTION_GET_EVENT_STAFFING',
        updateEventStaffing: 'ACTION_BLOCK_OPEN_STAFFING',
        getEventStaff: 'ACTION_GET_EVENT_STAFF',
        clearSlot: 'ACTION_CLEAR_SLOT',
        addOrRemove: 'ACTION_ADD_STAFF_SLOT',
        getSBWorkgroups: 'ACTION_GET_SB_WORKGROUPS',
        updateEventShiftboard: 'ACTION_UPDATE_EVENT_SHIFTBOARD'
      }),
      ...mapMutations({
        setIsLoading: 'MUTATION_SET_IS_LOADING'
      }),
      onCancelAllAppointments () {
        this.$modal.show('modalCancellAllAppointment');
      }
    },
    computed: {
      getStaffingDuration () {
        return this.event.staffingDuration;
      },
      ...mapGetters({
        getIsLoading: 'GETTER_IS_LOADING_MODAL',
        getInfoForMaxVale: 'GETTER_GET_EVENT_FOR_CHANGE_ORDER'
      })
    }
  };
</script>
<style lang="less" scoped>
  @import '../../styles/variables.less';
  .custom-modal {
    background: rgba(0, 0, 0, 0.4);
    min-height: 100vh;

    .modal-padding {
      padding-top: 24px;
      min-height: 100vh;
    }

    .modal-close-img {
      display: flex;
      justify-content: flex-end;

      &:hover{
        cursor: pointer;
      }
      .icon-close {
        margin: 1.5px 1.5px;
        width: 16px;
        height: 16px;
        color: @black-3;
        background-color: @black-3;
        -webkit-mask: url('../../../static/img/action-close-black.svg') no-repeat center;
        mask: url('../../../static/img/action-close-black.svg') no-repeat center;
        background: url('../../../static/img/action-close-black.svg');
      }
    }

    .icon-back {
      margin: 1.5px 1.5px;
      width: 27px;
      height: 27px;
      color: @grey-3;
      background-color: @grey-3;
      -webkit-mask: url('../../../static/img/backward-line.svg') no-repeat center;
      mask: url('../../../static/img/backward-line.svg') no-repeat center;
      background: url('../../../static/img/backward-line-grey.svg');

      &:hover{
        cursor: pointer;
      }
    }

    .icon-align {
      margin-top: 24px;
      margin-bottom: 10px;
      padding-left: 8px;
    }

    .staffing-section {
      //background-color: @white;
      padding-left: 30px;
      margin-bottom: 50px;

      .duration-slide-container{
        .duration-slide{
          width: 184px;
          padding: 0 12px;
        }
        .change-duration-button {
          padding: 6px 24px;
          margin-left: 30px;
          background: @white;
          color: @blue-2;
          border: 1px solid @grey-3;
          opacity: 0.7;
        }
      }

      .btn-cancel{
        padding: 6px 24px;
        background: @white;
        color: @blue-2;
        border: 1px solid @grey-3;
        border-radius: 4px;
        opacity: 0.7;
        margin-top: 6px;
      }

      .time-management-container{
        display: flex;
        align-items: flex-end;
        padding: 0 0.7rem;


      }

      .group-btn{
        .ap-btn{
          font-size: 16px;
          font-weight: 600;
          padding: 6px 24px;
          & + .ap-btn {
            margin-left: 8px;
          }
        }
      }

      .slots-configuration {
        color: #1D1D1D;
        font-family: @font-family-main;
        font-size: 24px;
        font-weight: 600;
        letter-spacing: 0.2px;
        line-height: 32px;
      }

      .seperate-name {
        border-left: 1.5px solid #B9B9B9;
        height: 20px;
        margin: 0 1rem;
        //position: relative;
        top: 5px;
      }

      .time-slots {
        color: #444444;
        font-family: @font-family-main;
        font-size: 20px;
        font-weight: bold;
        letter-spacing: 0.17px;
        line-height: 28px;
        margin-top: 40px;
        margin-right: 35px;
      }
      .staffing-title {
        color: @black-1;
        font-family: @font-family-main;
        font-size: 12px;
        letter-spacing: 0.1px;
        line-height: 16px;
        text-transform: uppercase;
        margin-top: 20px;
        margin-bottom: 15px;
      }
      .label {
        color: @white;
        font-family: @font-family-main;
        font-size: 16px;
        font-weight: 600;
        letter-spacing: 0.1px;
        line-height: 20px;
        text-transform: uppercase;
        position: relative;
        top: 50%;
        left: 50%;
        float: left;
        transform: translate(-50%, -50%);
      }
      .add {
        height: 32px;
        width: 83px;
        background-color: #00A4D6;
        border-radius: 4px;
        display: inline-block;
        cursor: pointer;
      }
      .remove {
        height: 32px;
        width: 114px;
        background-color: #FF3400;
        border-radius: 4px;
        display: inline-block;
        margin-left: 4px;
        cursor: pointer;
      }
      .screeners-label {
        color: @grey-8;
        font-family: @font-family-main;
        font-size: 16px;
        line-height: 24px;
      }
      .screener-number {
        display: inline-block;
        width: 106px;
      }
      .screener-wrapper {
        background-color: @white;
        width: 1023px;
        border-radius: 4px;
      }
    }
    .isLoading {
      display: block;
      text-align: center;
      color: #606060;
      height: 100%;
    }

    .noDisplay {
      display: none;
    }

    .overlay {
      position: relative;
      width: 100%;
      height: 100vh;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 999;
      cursor: pointer;
    }

    .spinner-align {
      position: absolute;
      top: 50%;
      left: 50%;
      font-size: 50px;
      color: white;
      transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
    }

    .text-entry-field-wrapper{
      .text-entry-title{
        color: @black-3;
        font-size: 12px;
        line-height: 28px;
        text-transform: capitalize;
      }

      .text-input {
        height: 32px;
        width: 100%;
        border: 1px solid #B9B9B9;
        border-radius: 4px;
        padding: 4px 8px;

        &::placeholder {
          font-size: 12px;
          color: @grey-12;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// EventStaffingDetail.vue?44cf8b35